<div class="p-5">
    <div class="space-b mb-3">
        <h1 class="font-weight-600">{{label}}</h1>
        <button mat-raised-button *ngIf="isDialog" color="primary" (click)="onDismiss()">
            <!-- <mat-icon>close</mat-icon> -->
            {{'DIALOGS.ACTIONS.CLOSE' | translate}}
        </button>
    </div>
        

        <app-simple-file-uploader [multiple]="true"
                                  class="uploader"
                                  #fileUploader
                                  [initialData]="initialData"
                                  [allowedExtensions]="allowedExtensions"
                                  [endpoint]="uploadEndpoint">
            <div class="uploader-content">
                <div class="mb-3" style="display: flex;">
                    <table mat-table [dataSource]="matDatasource" class="mat-elevation-z5 my-8" [ngStyle]="{ width: '100%' }"><!-- [ngStyle.gt-xs]="'width:100%'" -->
                        <ng-container matColumnDef="name">
                            <th style="min-width: 180px;" class="pt-16" fxFlex.gt-xs="45%" mat-header-cell *matHeaderCellDef> {{"FILE-MANAGER.TABLE.NAME" | translate}} </th>
                            <td mat-cell *matCellDef="let file" class="p-8" fxFlex.gt-xs="45%"> {{file.name}} </td>
                        </ng-container>
                        <ng-container matColumnDef="type">
                            <th style="width: 180px;" class="d-none d-lg-table-cell pt-16" fxFlex.gt-xs="30%" mat-header-cell *matHeaderCellDef> {{"FILE-MANAGER.TABLE.TYPE" | translate}} </th>
                            <td mat-cell class="d-none d-lg-table-cell p-8" *matCellDef="let file" fxFlex.gt-xs="30%"> {{file.mimeType}} </td>
                        </ng-container>
                        <ng-container matColumnDef="size">
                            <th style="width: 180px;" class="d-none d-lg-table-cell pt-16" fxFlex.gt-xs="15%" mat-header-cell *matHeaderCellDef> {{"FILE-MANAGER.TABLE.SIZE" | translate}} </th>
                            <td mat-cell class="d-none d-lg-table-cell p-8" *matCellDef="let file" fxFlex.gt-xs="15%"> {{file.fileLength}} </td>
                        </ng-container>
                        <ng-container matColumnDef="remove">
                            <th [ngStyle.gt-xs]="'width:180px'" fxFlex.gt-xs="20%" mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let file" fxFlex.gt-xs="20%">
                                <button mat-icon-button
                                        *ngIf="(isDialog && !readOnly) || (ngControl && !ngControl.disabled)"
                                        (click)="fileUploader.removeFile(file)"><mat-icon>cancel</mat-icon></button>
                                <button mat-icon-button
                                        (click)="fileUploader.downloadFile(file)"><mat-icon>get_app</mat-icon></button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngStyle.lt-md]="'min-height:80px'"></tr>
                    </table>

                </div>
                <div align="end">
                    <button mat-raised-button
                        *ngIf="(isDialog && !readOnly) || (ngControl && !ngControl.disabled)"
                        color="primary"
                        class="my-8"
                        (click)="fileUploader.openSelectFile()">
                        {{'BUTTONS.ATTACH' | translate}}
                        <mat-icon>file_upload</mat-icon>
                    </button>
                </div>
            </div>
            <div class="uploading-overlay" *ngIf="fileUploader.filesStatus?.length">
                <div class="uploading-video-data" *ngFor="let upload of fileUploader.filesStatus">
                    <!-- <mat-progress-bar style="grid-area: progress; margin: auto;"
                                      color="accent"
                                      *ngIf="upload.progress"
                                      [mode]="'buffer'"
                                      [value]="upload.progress" >
                    </mat-progress-bar> -->
                    <mat-spinner [diameter]="35"></mat-spinner>
                    <button mat-icon-button *ngIf="isDialog || (ngControl && !ngControl.disabled)" style="grid-area: cancel" (click)="upload.data.remove()"><mat-icon>cancel</mat-icon></button>

                </div>
            </div>
        </app-simple-file-uploader>


<!--        <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">-->
<!--            <input matInput [formControl]="ngControl.control"-->
<!--                [placeholder]="placeholder"-->
<!--                [type]="inputType"-->
<!--                #textInput>        -->
<!--            -->

<!--            -->
<!--            &lt;!&ndash; errors &ndash;&gt;-->
<!--            &lt;!&ndash; <mat-hint *ngIf="ngControl.control.errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.email">{{'AUTH.VALIDATION.INVALID_EMAIL' | translate}} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.maxlength">{{'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.max">{{'AUTH.VALIDATION.MAX_VALUE' | translate }} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.min">{{'AUTH.VALIDATION.MIN_VALUE' | translate }} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.pattern">{{'AUTH.VALIDATION.BAD_FORMAT' | translate }} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.blankSpaces">{{'AUTH.VALIDATION.BLANK_FIELD' | translate }} &nbsp;</mat-hint> &ndash;&gt;-->
<!--            -->
<!--        </mat-form-field>-->
            
        <!-- <ng-container *ngIf="ngControl && ngControl.control.valid"> -->
            <!-- <div fxLayout="row" fxLayoutAlign="flex-end" class="input-text-hint"> -->
<!--                <mat-hint>{{textInput.value.length}} / {{maxLength}}</mat-hint>-->
            <!-- </div>  -->
        <!-- </ng-container> -->
        <ng-container *ngIf="ngControl && ngControl.touched">
            <mat-error *ngIf="ngControl.control.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('email')">{{'INPUT.INVALID_EMAIL' | translate}}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('maxLength')">{{'INPUT.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('max')">{{'INPUT.MAX_VALUE' | translate }}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('min')">{{'INPUT.MIN_VALUE' | translate }}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('pattern')">{{'INPUT.BAD_FORMAT' | translate }}</mat-error>

        </ng-container>
<!--    <ng-container *ngIf="ngControl.control.disabled">-->
<!--        <mat-label class="font-weight-400">{{label}}</mat-label>-->
<!--        <p style="font-weight: bold;" *ngFor="let file of initialData">{{file.name}}</p>-->
<!--    </ng-container>-->
</div>
